export default function getExtension(filename) {
  var extension = filename.split("/").pop().toLowerCase();
  return extension;
}
